import React from "react";
import { Card, Box, Avatar, Typography, Divider } from "@mui/material";

interface Props {
  icon?: React.ReactNode | string;
  title: string;
  value: string | number;
  footer?: string;
}

const SummaryCard: React.FC<Props> = ({ icon, title, value, footer }) => {
  return (
    <Card className="saloon-summary-card">
      <Box className="saloon-card-header">
        <Avatar className="saloon-card-avatar">{icon}</Avatar>
        <Typography variant="h6" sx={{ fontWeight: 600 }}>
          {title}
        </Typography>
      </Box>

      <Typography variant="h4" sx={{ mt: 1 }}>
        {value}
      </Typography>

      <Divider sx={{ my: 1 }} />

      {footer && <Typography variant="body2">{footer}</Typography>}
    </Card>
  );
};

export default SummaryCard;
